module.exports = __webpack_public_path__ + "img/stationary.90d79ccb.png";